
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import FontFamilyInput from "@/components/Reusable/CustomInputs/FontFamily/FontFamilyInput.vue";
import { Control } from "@/oxygen/classes/lib/types";

@Component({
  components: { FontFamilyInput }
})
export default class OxygenFontFamilyInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input", { type: String })
  syncedValue?: string;
}
